<div class="gt-content">
  <gt-card-wrapper cardTitle="{{ 'sp.search_user' | translate }}" matIcon="group" fxFill>
    <div fxLayout="column" fxLayoutGap="10px">
      <div fxFlex="20">
        <mat-form-field>
          <mat-label>{{ 'sp.search_user' | translate }}</mat-label>
          <input matInput #filter />
          <button mat-icon-button matSuffix (click)="search(filter.value.trim())"><mat-icon>search</mat-icon></button>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxFill>
        <mat-progress-bar mode="indeterminate" *ngIf="showLoading" [@fadeIn]="'shown'"></mat-progress-bar>
        <mat-table [dataSource]="dataSource" matSort #sortForDataSource="matSort" fxFill>
          <!-- Column Definition: organization -->
          <ng-container matColumnDef="organization">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.organization' | translate }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.organization }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: name -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.name' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.name }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: number -->
          <ng-container matColumnDef="number">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'global.number' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.number }}
            </mat-cell>
          </ng-container>

          <!-- Short number column -->
          <ng-container matColumnDef="short-number">
            <mat-header-cell *matHeaderCellDef>{{ 'contacts.col_short' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ row.shortNumber }}
            </mat-cell>
          </ng-container>

          <!-- Type column -->
          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef>{{ 'contacts.col_type' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let row">
              {{ getContactTypeDisplayName(row.type) | translate }}
            </mat-cell>
          </ng-container>

          <!-- Column Definition: actions -->
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="right-aligned-table-column"> </mat-header-cell>
            <mat-cell *matCellDef="let row" class="right-aligned-table-column">
              <button mat-icon-button (click)="showRow(row)" matTooltip="{{ 'global.configure' | translate }}">
                <mat-icon>settings</mat-icon>
              </button>
              <button mat-icon-button (click)="showProfile(row)">
                <mat-icon>open_in_browser</mat-icon>
              </button>
              <button
                *ngIf="hasEditEndUserRights()"
                mat-icon-button
                (click)="editRow(row)"
                class="edit-button"
                matTooltip="{{ 'global.edit' | translate }}"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="dataSourceColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: dataSourceColumns"> </mat-row>
        </mat-table>
      </div>
      <mat-paginator #paginatorForDataSource [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 100]" (page)="paging($event)">
      </mat-paginator>
    </div>
  </gt-card-wrapper>
</div>
